import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import * as Yup from 'yup';


import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { PostLimitData } from '../../../../Axios/LimitManagement';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Stack } from '@mui/system';




const Topup = () => {
  const[openAlert,setOpenAlert]=useState(false)
  const[alertType,setAlertType]=useState('success')
  const[alertMessage,setAlertMessage]=useState(null)

  // const handleOptionChange = (event) => {
  //   setAge(event.target.value);
  // };

  



  const handlepostRequest = (data) => {
    PostLimitData(PostBankDetails, data,setOpenAlert,setAlertType,setAlertMessage)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };

  console.log(File);

  return (
    <div style={{ height: '70vh', paddingBottom: useMediaQuery('(max-width:600px)') ? '100px' : '0px', overflowY: 'scroll', scrollbarWidth: 'none' }}>
      <Formik
        initialValues={{
          ko_code: '',
          amount: ''
        }}
        validationSchema={Yup.object().shape({
          
          ko_code: Yup.string().required('This field is required'),
          amount: Yup.string().required('Amount is required'),
          
        })}
        onSubmit={(values, { setSubmitting }) => {
          try {

            handlepostRequest({ ...values, bank_recipt: File })
            setSubmitting(false);
          } catch (error) {
            console.log(error);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit} style={{ marginBlock: '50px' }}>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'top',horizontal:'right'}}>
              <Alert
                onClose={handleClose}
                severity={alertType}
                variant="filled"
                sx={{ width: '100%' }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
            <Grid container spacing={2}>
              <Grid item xl={6} md={6} sm={12} xs={12}>
                <Stack direction='row' gap={1}>
                  <Typography color='error' variant='h4'>Available: </Typography>
                  <Typography variant='h4'>12000</Typography>
                </Stack>
              </Grid>

              <Grid item xl={6} md={6} sm={12} xs={12}>
                <Stack direction='row' gap={1}>
                  <Typography color='error' variant='h4'>Remaining Amount: </Typography>
                  <Typography variant='h4'>8000</Typography>
                </Stack>
              </Grid>

              <Grid item xl={12} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="ko_code"
                  label="KO Code"
                  error={errors.ko_code && touched.ko_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ko_code}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.ko_code && touched.ko_code && errors.ko_code}
                </Typography>
              </Grid>


            
              <Grid item xl={12} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Amount"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

             
              <Grid display='flex' item xl={12} lg={12} md={12} sm={12} xs={12} justifyContent='flex-end'>
                <Button type="submit" variant='contained' size='small' color='secondary' disabled={isSubmitting}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </div>
  )

};

export default Topup;


